import React from 'react';
import { P, match } from 'ts-pattern';
import { useNightingale } from '#/lib/nightingale';
import type { ToolInvocationUIPart } from '../types';
import ChatMessagePartToolDocGenerated from './chat-message-part-tool-doc-generated';
import ChatMessagePartToolDocSearchJoggr from './chat-message-part-tool-doc-search-joggr';
import ChatMessagePartToolGitHubContentsDirectoryRead from './chat-message-part-tool-github-contents-directory-read';
import ChatMessagePartToolGitHubContentsFileRead from './chat-message-part-tool-github-contents-file-read';
import ChatMessagePartToolGitHubRepoList from './chat-message-part-tool-github-repo-list';
import ChatMessagePartToolGitHubSearchCode from './chat-message-part-tool-github-search-code';
import ChatMessagePartToolGitHubTreeRead from './chat-message-part-tool-github-tree-read';

export interface ChatMessagePartToolInvocationProps {
  messageId: string;
  part: ToolInvocationUIPart;
}

function ChatMessagePartToolInvocation({
  messageId,
  part,
}: ChatMessagePartToolInvocationProps) {
  const nightingale = useNightingale();

  const handleEngage = React.useCallback(() => {
    nightingale.capture(['engage', 'ai_chat'], {
      messageId,
      type: 'tool_invocation',
      toolInvocationId: part.toolInvocation.toolCallId,
      toolName: part.toolInvocation.toolName,
    });
  }, [nightingale, messageId, part.toolInvocation]);

  return match(part.toolInvocation)
    .returnType<React.ReactNode>()
    .with(P.nullish, () => null)
    .with({ toolName: 'generated-doc', state: 'result' }, (toolInvocation) => (
      <ChatMessagePartToolDocGenerated
        messageId={messageId}
        toolInvocation={toolInvocation}
        onEngage={handleEngage}
      />
    ))
    .with({ toolName: 'github-contents-directory-read' }, (toolInvocation) => (
      <ChatMessagePartToolGitHubContentsDirectoryRead
        messageId={messageId}
        // @ts-expect-error - TODO: fix later
        toolInvocation={toolInvocation}
        onEngage={handleEngage}
      />
    ))
    .with({ toolName: 'github-contents-file-read' }, (toolInvocation) => (
      <ChatMessagePartToolGitHubContentsFileRead
        messageId={messageId}
        // @ts-expect-error - TODO: fix later
        toolInvocation={toolInvocation}
        onEngage={handleEngage}
      />
    ))
    .with({ toolName: 'doc-search-joggr' }, (toolInvocation) => (
      <ChatMessagePartToolDocSearchJoggr
        messageId={messageId}
        // @ts-expect-error - TODO: fix later
        toolInvocation={toolInvocation}
        onEngage={handleEngage}
      />
    ))
    .with({ toolName: 'github-repo-list' }, (toolInvocation) => {
      return (
        <ChatMessagePartToolGitHubRepoList
          messageId={messageId}
          // @ts-expect-error - TODO: fix later
          toolInvocation={toolInvocation}
          onEngage={handleEngage}
        />
      );
    })
    .with({ toolName: 'github-tree-read' }, (toolInvocation) => {
      return (
        <ChatMessagePartToolGitHubTreeRead
          messageId={messageId}
          // @ts-expect-error - TODO: fix later
          toolInvocation={toolInvocation}
          onEngage={handleEngage}
        />
      );
    })
    .with({ toolName: 'github-search-code' }, (toolInvocation) => {
      return (
        <ChatMessagePartToolGitHubSearchCode
          messageId={messageId}
          // @ts-expect-error - TODO: fix later
          toolInvocation={toolInvocation}
          onEngage={handleEngage}
        />
      );
    })
    .otherwise(() => null);
}

export default React.memo(ChatMessagePartToolInvocation);
